import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useZuschlagsgruppen } from '@/domain/mitarbeiter/features/anlageassistent/hooks/useZuschlagsgruppen/useZuschlagsgruppen';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { useTranslation } from 'react-i18next';

export function Zuschlaege() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const data = form.state.values;
  const { currentStandort } = useStandortContext();
  const { zuschlagsgruppen } = useZuschlagsgruppen(currentStandort.id);
  return (
    <div className="py-2 grid grid-cols-2 gap-y-4 text-neutrals-800 leading-5 text-sm font-normal">
      <span>
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.zuschlaege.form.zuschlaege.zusammenfassung.label',
        )}
      </span>

      <span className="text-neutrals-900 font-semibold">
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.zuschlaege.form.zuschlaege.zusammenfassung.options.' +
            data.bezahlung.zuschlaege.zuschlaege,
        )}
      </span>
      <span>
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.zuschlaege.form.zuschlagsgruppe.label',
        )}
      </span>

      <span className="text-neutrals-900 font-semibold">
        {zuschlagsgruppen.find(
          (z) => z.id === data.bezahlung.zuschlaege.zuschlagsgruppe,
        )?.name || ''}
      </span>
      <span>
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.zuschlaege.form.pauschaleZuschlaege.label',
        )}
      </span>

      <span className="text-neutrals-900 font-semibold">
        {`${data.bezahlung.zuschlaege.pauschaleZuschlaege || '0,00'} €`}
      </span>
      <span>
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.zuschlaege.form.uebertariflicheZahlung.label',
        )}
      </span>

      <span className="text-neutrals-900 font-semibold">
        {`${data.bezahlung.zuschlaege.uebertariflicheZahlung || '0,00'} €`}
      </span>
    </div>
  );
}
